import type { FunctionComponent, TargetedMouseEvent } from 'preact';

import type { VehicleWidgetTemplateParams } from 'Components/fitmentSearch/vehicleWidget/vehicleWidget';
import type { TemplateFunction, TemplateFunctionInvoker } from 'Components/types';
import type { FacetValueFull, SelectionEntry } from 'Models/index';
import { cloneSafe } from 'Utils/components';

import { getImageOrDefault, getParams, type SubvalueParams } from './tile';

type Props = {
  template: TemplateFunction<SubvalueParams>;
  subvalue: FacetValueFull;
  hasSubvalues?: boolean;
  isMultiLevel?: boolean;
  toggleFacet: (term: string) => void;
  useFilterMode?: boolean;
  vehicleFromUriSelection: SelectionEntry[];
  fitmentFields: string[];
  vehicleWidget?: TemplateFunctionInvoker<VehicleWidgetTemplateParams>;
};

const Subtile: FunctionComponent<Props> = ({
  template,
  subvalue,
  hasSubvalues,
  isMultiLevel,
  toggleFacet,
  useFilterMode,
  vehicleFromUriSelection,
  fitmentFields,
  vehicleWidget,
}) => {
  const component = template.call({
    ...getParams(subvalue, vehicleFromUriSelection, fitmentFields),
    hasSubvalues,
    isMultiLevel,
    getImageOrDefault,
    vehicleWidget,
  });

  const options = useFilterMode
    ? {
        onClick: (e: TargetedMouseEvent<HTMLElement>) => {
          e.preventDefault();
          toggleFacet(subvalue.term);
        },
      }
    : {};

  return cloneSafe(component, null, { ...options });
};

export default Subtile;
